/* Types */
import { Mode } from '@/types/main'

/**
 * Получаем домен первого уровня (ru/com/kg...)
 * @param hostname - домен подключения
 * @param mode - окружение приложения
 */
export const getFirstLevelDomain = (hostname: string, mode: Mode) => {
  const domain = hostname.split('.')?.at(-1) || 'ru'

  if ([Mode.DEVELOPMENT, Mode.BRANCH].includes(mode)) return 'ru'

  return domain
}
